/**
 * Placeholder for provider licensure / service-area validation against client attested state.
 *
 * TODO: Wire to Practitioner.qualification jurisdiction-state and practice service areas.
 * For MVP this returns non-blocking results so clinical workflows are not halted.
 */
export interface LicensureCheckInput {
  attestedState: string;
  practitionerId?: string;
}

export interface LicensureCheckResult {
  blocking: boolean;
  reason?: string;
}

export function checkLicensureForSessionLocation(_input: LicensureCheckInput): LicensureCheckResult {
  return { blocking: false };
}
